<template>
    <div class="house-card" @click="toDetail">
        <div class="img-content">
            <img :src="`/api/v1/file/${item.cover}`" alt="" class="house-card-img">
        </div>
        <img v-if="item.user_portrait" :src="`/api/v1/file/${item.user_portrait}`" class="house-user-img" alt="">
        <div class="card-name" :class="{'top-20': !showAddress}" :title="item.title">{{item.title}}</div>
        <div v-if="showAddress" class="card-address">{{item.address}}</div>
        <!--<div v-else class="card-address"></div>-->
        <div class="card-bottom">
            <div class="card-sub">价格：￥<span class="price-text">{{item.price|parseNum}}</span>/晚</div>
            <div class="card-sub">
                {{item.house_type}}-{{item.room_type}}-{{item.bed_count}}张床-{{item.max_people}}人
            </div>
            <div class="evaluate-content">
                <el-rate :value="+item.star|| 0"
                         disabled
                         show-score
                         disabled-void-color="#cccccc"
                         text-color="#ff9900"
                         style="display: flex;justify-content: flex-start;align-items: center"
                         score-template="{value}"></el-rate>
                <div>{{item.evaluate_count||item.evaluate_num||0}} 评价</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "HouseCard",
        props:{
            item: {
                type: Object,
                default(){
                    return {}
                }
            },
            showAddress:{
                type: Boolean,
                default: false
            }
        },
        methods:{
            toDetail(){
                this.$router.push({path: '/houseDetail', query:{id: this.item.id}})
            }
        }
    }
</script>

<style scoped lang="less">
    .house-card{
        width: 280px;
        height: 330px;
        margin: 10px;
        box-sizing: border-box;
        cursor: pointer;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        border-radius: 6px;
        overflow: hidden;
        position: relative;
        .house-user-img{
            position: absolute;
            width: 40px;
            height: 40px;
            border-radius: 100%;
            object-fit: cover;
            right: 10px;
            top: 192px;
            border: 2px solid #ffffff;
            z-index: 2;
            transform: translate(0, -50%);
            background-color: #fff;
        }
        &:hover{
            .house-card-img{
                transform: scale(1.1);
            }
            .card-name{
                color: #e44646;
            }
        }

        .img-content{
            width: 100%;
            height: 192px;
            overflow: hidden;
            position: relative;
            .house-card-img{
                width: 100%;
                height: 100%;
                object-fit: cover;
                transition: 0.3s;
            }
        }
        .card-name{
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
            white-space: nowrap;
            font-size: 18px;
            height: 34px;
            line-height: 34px;
            padding: 0 10px;
            box-sizing: border-box;
        }
        .card-address{
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: left;
            white-space: nowrap;
            font-size: 14px;
            padding: 0 10px;
            box-sizing: border-box;
            color: #9da6aa;
            min-height: 18px;
        }
        .card-bottom{
            padding: 0 10px;
            width: 100%;
            box-sizing: border-box;
            position: relative;
        }
        .evaluate-content{
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: #949494;
            font-size: 14px;
        }
        .card-sub{
            color: #949494;
            font-size: 14px;
            text-align: left;
            margin: 4px 0;
        }
        .price-text{
            font-size: 20px;
            color: #e44646;
        }
    }
    .top-20{
        margin-top: 20px;
    }
</style>
